export default __webpack_public_path__ + "static/media/ring.f9940c7b.jpg";